import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useMergeState } from 'irmlib/hooks'
import styled from 'styled-components'
import { YDivider } from 'irmlib/styles'

import { getUser } from '../../../../redux/global'
import { isAdmin, isSupervisor, doLogout, successToast, errorToast, isSuperUser } from '../../../../common/functions'
// import { ContainedButton, OutlinedButton } from '../../../../irmlib/src/components/Controls'
import * as gdeTransactions from '../../../../services/firestore'
import { gdeWorkerRole } from '../../../../services/firestore/login'
import { FormDialog } from '../../FormDialog'
import { userRoleSuperUser } from '../../../../common/constants'
import { closeGeneralDialog, setBusy, clearBusy } from '../../../../irmlib/src/containers'
// import { t } from 'i18n-js'
import { useTranslation } from 'react-i18next'

const AdditionalTitleContainer = styled.div`
  font-weight: bold;
  flex-direction: column;
  align-items: left;
`

export const UpdateDistrict = (props) => {
  const { t } = useTranslation()
  const [state, setState, getState] = useMergeState({
    districtsList: [],
    countryList: [],
    ChangeDistrictRequest: false,
    gdeRole: '',
  })
  const [defaultDistrict, setDefaultDistrict] = useState(false)

  const { IsloginWithoutDistrict } = props
  
  useEffect(async () => {
    const workerRole = await gdeWorkerRole(getUser().workerId)
    const workerDetails = await gdeTransactions.getWorkerDetails(getUser().workerId)
    const countries = workerRole.data().country ? workerRole.data().country : []
    const countryData = countries 
      ? countries?.map((country, index) => ({
        value: country,
        label: country,
      }))
      : []
    const workCountry = workerDetails.data().country  
    if (workCountry && !countries.includes(workCountry)) {
      const data = {
        value: workCountry,
        label: workCountry
      }
      countryData.push(data)
    }

    const alternateCountry = workerDetails.data().alternateCountry
    if (alternateCountry && !countries.includes(alternateCountry)) {
      const data = {
        value: alternateCountry,
        label: alternateCountry
      }
      countryData.push(data)
    }
    setState({ countryList: countryData, gdeRole: workerRole.data().gdeRole })
    setState({ ChangeDistrictRequest: false })
  }, [])

  useEffect(() => {
    if (state?.ChangeDistrictRequest === true) {
      handleChangeDistrictOnClick(defaultDistrict)
      setState({ ChangeDistrictRequest: false })
    }
  }, [state?.ChangeDistrictRequest])

  const getCountryDetails = async () => {
    const countryDetails = []
    await gdeTransactions.getCountries().then((result) => {
      if (result) {
        result.forEach((doc) => {
          countryDetails.push({ id: doc.id, countryName: doc.data().countryName })
        })
      }
    })
    return countryDetails
  }

  const getDistricts = async (country = '') => {
    setBusy()
    try {
      const districtsListNew = []
      const workerDetails = await gdeTransactions.getWorkerDetails(getUser().workerId)
      let districtSrNo = 0
      if (country === null || country === undefined) {
        setState({ districtsList: districtsListNew })
      }
      if (country === '') {
        if (workerDetails?.data()?.country) {
          const collection = await gdeTransactions.getLocationsForCountry(workerDetails.data().country)
          collection.forEach((doc) => {
            districtsListNew.push({ 
              value: districtSrNo++,
              districtName: doc.data().districtName, 
              countryCode: workerDetails.data().countryCode, 
              countryName: workerDetails.data().country, 
              label: `${workerDetails.data().country} : ${doc.data().districtName}` 
            })
          })
        }
      
        if (workerDetails?.data()?.alternateCountry) {
          const collection1 = await gdeTransactions.getLocationsForCountry(workerDetails.data().alternateCountry)
          collection1.forEach((doc) => {
            districtsListNew.push({ 
              value: districtSrNo++,
              districtName: doc.data().districtName, 
              countryCode: workerDetails.data().alternateCountryCode,
              countryName: workerDetails.data().alternateCountry, 
              label: `${workerDetails.data().alternateCountry} : ${doc.data().districtName}` 
            })
          })
        }
        getState().gdeRole.toUpperCase() !== userRoleSuperUser && setState({ districtsList: districtsListNew })
      } else {
        const collection2 = await gdeTransactions.getLocationsForCountry(country)
        const countryList = await getCountryDetails()
        const districtsListNew = []
        
        collection2.forEach((doc) => {
          const resultCountry = countryList.find((countryData) => countryData.countryName === country)
          const countryCode = resultCountry ? resultCountry.id : null
          districtsListNew.push({
            value: districtSrNo++,
            districtName: doc.data().districtName,
            countryCode: countryCode,
            countryName: country,
            label: doc.data().districtName,
          })
        })
        setState({ districtsList: districtsListNew })
      }
      clearBusy()
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
      clearBusy()
    }
  }

  // const ConfirmButtonsForChangeDistrict = () =>
  //   <>
  //     <OutlinedButton onClick={closeGeneralDialog} >buttons.no</OutlinedButton>
  //     <ContainedButton onClick={handleChangeDistrictYes} >buttons.yes</ContainedButton>
  //   </>

  const handleChangeDistrictYes = async () => {
    setState({ ChangeDistrictRequest: true })
  }

  // const confirmChangeDistrictOnClick = async () => {
  //   openGeneralDialog({
  //     title: 'dashBoard.changeDistrict',
  //     message: 'dashBoard.changeDistrictConfirm',
  //     translateMessage: true,
  //     buttons: <ConfirmButtonsForChangeDistrict />,
  //     closeX: true
  //   })
  // }

  const handleChangeDistrictOnClick = async () => {
    if (defaultDistrict === false || defaultDistrict === '' || defaultDistrict === undefined) {
      errorToast({ message: t('toast.invalidDistrict'), title: t('toast.error') })
    } else {
      const newDistrict = getState().districtsList[defaultDistrict].districtName
      const countryCode = getState().districtsList[defaultDistrict].countryCode
      const countryName = getState().districtsList[defaultDistrict].countryName
      await gdeTransactions.updateWorkerDistrict(getUser().workerId, newDistrict, countryCode, countryName)
      const localStorageDashboardDistrictKey = 'localDashboardDistrict'
      const localStorageDashboardBuildingKey = 'localDashboardBuilding'
      const localStorageDashboardDistrictKey2 = 'dashboardDistrict'
      const localStorageDashboardBuildingKey2 = 'dashboardBuilding'
      const localStorageDashboardPrevCountryKey = 'previousCountry'
      const persistedCountry = JSON.parse(localStorage.getItem(localStorageDashboardPrevCountryKey))
      const persistedDistrict = JSON.parse(localStorage.getItem(localStorageDashboardDistrictKey))
      const persistedDistrict2 = JSON.parse(localStorage.getItem(localStorageDashboardDistrictKey2))
      if (persistedCountry?.country === getUser()?.country) {
        localStorage.setItem(localStorageDashboardDistrictKey, JSON.stringify({ district: persistedDistrict?.district || newDistrict }))
        localStorage.setItem(localStorageDashboardDistrictKey2, JSON.stringify({ district: persistedDistrict2?.district || newDistrict }))
        localStorage.setItem(localStorageDashboardBuildingKey, JSON.stringify({ building: null }))
        localStorage.setItem(localStorageDashboardBuildingKey2, JSON.stringify({ building: null }))
      } else {
        localStorage.setItem(localStorageDashboardDistrictKey, JSON.stringify({ district: null }))
        localStorage.setItem(localStorageDashboardDistrictKey2, JSON.stringify({ district: null }))
        localStorage.setItem(localStorageDashboardBuildingKey, JSON.stringify({ building: null }))
        localStorage.setItem(localStorageDashboardBuildingKey2, JSON.stringify({ building: null }))
      }
      
      successToast({ message: t('toast.successDistrictChange'), title: t('toast.success') })
      doLogout()
    }

    closeGeneralDialog()
  }

  return (
    IsloginWithoutDistrict
      ? (
        <AdditionalTitleContainer>
          {!isAdmin() && !isSupervisor() && !isSuperUser() &&
          <>
            <YDivider height='10px' />
            {`${t('dashBoard.currentDistrict', { districtName: getUser()?.district })}`}
          </>}
          <YDivider height='10px' />
          <FormDialog 
            role={getState().gdeRole}
            setDistrict= {setDefaultDistrict}
            getDistrict= {getDistricts}
            countryList= {getState().countryList}
            districtsList= {getState().districtsList}
            confirmChangeDistrictOnClick= {handleChangeDistrictYes}
            IsloginWithoutDistrict = {IsloginWithoutDistrict}
        />
          <YDivider height='10px' />
        </AdditionalTitleContainer>
        )
      : <FormDialog 
          role={getState().gdeRole}
          setDistrict= {setDefaultDistrict}
          getDistrict= {getDistricts}
          countryList= {getState().countryList}
          districtsList= {getState().districtsList}
          confirmChangeDistrictOnClick= {handleChangeDistrictYes}
          IsloginWithoutDistrict= {IsloginWithoutDistrict}
  />
  )
}

UpdateDistrict.propTypes = {
  IsloginWithoutDistrict: PropTypes.bool.isRequired,
}


